"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playwrightGoto = exports.playwrightGotoResultSchema = exports.playwrightGotoArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.playwrightGotoArgsSchema = zod_1.z.object({
    url: zod_1.z
        .string()
        .describe('required: The URL to navigate to and fetch content from. Supports flexible URL formats - protocol is optional and will be auto-normalized. Examples: "https://example.com", "www.example.com", "example.com", "subdomain.example.com", "example.com/path"'),
    timeout: zod_1.z
        .number()
        .default(15000)
        .describe('required: The timeout for the fetch in milliseconds. Default 15000.'),
    emitMode: common_1.emitModeSchema,
});
// Result schema
exports.playwrightGotoResultSchema = zod_1.z.object({
    success: zod_1.z.boolean().describe('Whether the URL fetch was successful'),
    status: zod_1.z.number().describe('HTTP status code of the response'),
    content: zod_1.z.string().nullish().describe('The HTML content of the web page'),
    text: zod_1.z
        .string()
        .nullish()
        .describe('The extracted text content from the web page (cleaned and readable)'),
    metadata: zod_1.z
        .object({
        description: zod_1.z.string().describe('Meta description from the page'),
        ogTitle: zod_1.z.string().describe('Open Graph title from the page'),
        ogDescription: zod_1.z.string().describe('Open Graph description from the page'),
    })
        .nullish()
        .describe('Metadata extracted from the page (meta tags, Open Graph, etc.)'),
    error: zod_1.z.string().nullish().describe('Error message if the fetch failed'),
});
// Tool definition
exports.playwrightGoto = (0, common_1.createEmitModeToolMetadata)({
    id: 'playwrightGoto',
    displayName: 'Web Page Fetch',
    displayDescription: 'Navigate to any URL and extract page text content and metadata. Accepts flexible URL formats: full URLs (https://example.com), domains (example.com), subdomains (www.example.com), and paths (example.com/page). Protocol auto-added if missing.',
    category: 'search',
    color: common_1.BRAND_COLORS.BROWSER,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.BROWSER),
    icon: 'browser',
    argsSchema: exports.playwrightGotoArgsSchema,
}, exports.playwrightGotoResultSchema);
